import {
  AppBar,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Container,
  Paper,
  Stack,
  Tab,
  Tabs,
  Toolbar,
} from '@mui/material';
import { NavLink, Outlet, useLocation } from 'react-router';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { FaiscaCredito } from '@/components/brand/FaiscaCredito';
import { ColorModeToggle } from '@/components/ColorModeToggle';
import { PageTransition } from '@/components/PageTransition';
import { brand } from '@/config/brand';
import { AccountMenu } from './AccountMenu';
import { useEu } from '@/features/notas/EuContext';
import { Rastro } from '@/features/notas/rastro';
import { activeNavItem, itensVisiveis } from './navigation';

export function AppLayout() {
  const { pathname } = useLocation();
  const { eu } = useEu();
  const itens = itensVisiveis(eu);
  const current = activeNavItem(pathname, itens);

  return (
    <Box sx={{ minHeight: '100dvh', pb: { xs: 11, md: 0 } }}>
      <Rastro />
      <AppBar position="sticky">
        <Toolbar sx={{ gap: 3, minHeight: { xs: 60, sm: 64 } }}>
          {brand.needsSetup ? (
            // Placeholder is itself a button (opens the brand guide), so no link around it.
            <BrandLogo size="small" />
          ) : (
            <NavLink
              to="/"
              style={{ textDecoration: 'none', color: 'inherit' }}
              aria-label="Início"
            >
              <BrandLogo size="small" />
            </NavLink>
          )}
          <Tabs
            value={current}
            component="nav"
            aria-label="Navegação principal"
            sx={{
              display: { xs: 'none', md: 'flex' },
              minHeight: 64,
              '& .MuiTab-root': { minHeight: 64 },
            }}
          >
            {itens.map((item) => (
              <Tab
                key={item.to}
                value={item.to}
                label={item.label}
                component={NavLink}
                to={item.to}
              />
            ))}
          </Tabs>
          <Stack direction="row" spacing={0.5} sx={{ ml: 'auto', alignItems: 'center' }}>
            <ColorModeToggle />
            <AccountMenu />
          </Stack>
        </Toolbar>
      </AppBar>

      <Container component="main" maxWidth="lg" sx={{ pt: { xs: 3, md: 4 }, pb: 6 }}>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </Container>

      <Paper
        component="nav"
        aria-label="Navegação principal"
        sx={{
          display: { md: 'none' },
          position: 'fixed',
          insetInline: 0,
          bottom: 0,
          zIndex: 'appBar',
          borderRadius: 0,
        }}
      >
        <BottomNavigation value={current} showLabels>
          {itens.map((item) => (
            <BottomNavigationAction
              key={item.to}
              value={item.to}
              label={item.label}
              icon={<item.icon />}
              component={NavLink}
              to={item.to}
            />
          ))}
        </BottomNavigation>
      </Paper>

      {/* Crédito do template Faísca: centralizado, no fim da página. */}
      <Container maxWidth="lg" component="footer" sx={{ pb: { xs: 4, md: 5 } }}>
        <Box sx={{ pt: 3, borderTop: 1, borderColor: 'divider', display: 'flex', justifyContent: 'center' }}>
          <FaiscaCredito />
        </Box>
      </Container>
    </Box>
  );
}
